
import { defineComponent } from 'vue';
import { useLoginLabels } from 'client/util/Constants/LoginLabels';

export default defineComponent({
  name: 'DurtDeviceValidatingPanel',

  setup() {
    const uiLabel = useLoginLabels();
    return { uiLabel };
  },
});
